import { render, staticRenderFns } from "./Timer.vue?vue&type=template&id=2ca976e2&scoped=true&"
import script from "./Timer.vue?vue&type=script&lang=ts&"
export * from "./Timer.vue?vue&type=script&lang=ts&"
import style0 from "./Timer.vue?vue&type=style&index=0&id=2ca976e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca976e2",
  null
  
)

export default component.exports